import { render, staticRenderFns } from "./TestStartInfo.vue?vue&type=template&id=7895cf0e&scoped=true&"
import script from "./TestStartInfo.vue?vue&type=script&lang=js&"
export * from "./TestStartInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7895cf0e",
  null
  
)

export default component.exports